//      
import React from 'react';

import { Button } from 'bs';
import { mergeClassNames } from 'utils/functions';

              
                       
                  
                                          
                      
  

const CancelButton = ({ label, className, ...domProps }       ) => (
    <Button flavor='light' className={mergeClassNames('float-right', className)} {...domProps}>
        {label}
    </Button>
);

CancelButton.defaultProps = {
    label: 'Cancel',
    className: '',
};

export default CancelButton;
